import { BRAND_RCI } from 'contexts/CruiseSearchContext/constants';
import { GetLabelByBrandProps } from './getLabelByBrand.types';

const getLabelByBrand = ({ brand, labelRCI, labelCEL }: GetLabelByBrandProps): string => {
	return brand === BRAND_RCI.code ? labelRCI : labelCEL;
};

export default getLabelByBrand;
